import { useDispatch, useSelector } from 'react-redux';

import { RootDispatch, RootState } from 'storage/store';
import {
  ConfirmedStatement,
  NewConfirmedStatement,
  UpdateConsentRequest,
  UpdatedConsent
} from 'storage/statements/statement.model';

export const useStatementAndContents = () => {
  const dispatch = useDispatch<RootDispatch>();

  const consentToggle = useSelector(
    (state: RootState) => state.application?.consentsAndObligationsFeatureToggle
  );
  const { consents, statements } = useSelector(
    (state: RootState) => state.statements
  );

  const loadStatements = async () => {
    if (consentToggle) {
      await dispatch.statements.getStatements();
    } else {
      await dispatch.statements.getStatementsDeprecated();
    }
  };

  const loadConsents = async () => {
    if (consentToggle) {
      return dispatch.statements.getConsents();
    }
    return dispatch.statements.getConsentsDeprecated();
  };

  const turnOffStatements = async (
    statementsArray: NewConfirmedStatement[] | ConfirmedStatement[]
  ) => {
    if (consentToggle) {
      await dispatch.statements.turnOffStatements(
        statementsArray as NewConfirmedStatement[]
      );
    } else {
      await dispatch.statements.turnOffStatementsDeprecated(
        statementsArray as ConfirmedStatement[]
      );
    }
  };

  const updateConsents = async (
    consentsArray: UpdatedConsent[] | UpdateConsentRequest
  ) => {
    if (consentToggle) {
      return dispatch.statements.updateConsents(
        consentsArray as UpdatedConsent[]
      );
    }
    return dispatch.statements.updateConsentsDeprecated(
      consentsArray as UpdateConsentRequest
    );
  };

  return {
    statements,
    loadStatements,
    turnOffStatements,
    consents,
    loadConsents,
    updateConsents
  };
};
